import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-50 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-400 text-primary-950 text-lg">
                <i className="ri-film-line"></i>
              </span>
              <span className="font-heading font-semibold text-lg text-background-50">
                蜜桃成熟
              </span>
            </div>
            <p className="text-sm leading-relaxed text-primary-100/90">
              专注电影与电视剧内容聚合，提供最新影视动态、剧情资讯与丰富的片单推荐，帮助影视爱好者更轻松地发现好作品。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4 font-label tracking-wide">
              快速导航
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-primary-100/90 hover:text-background-50 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/movie"
                  className="text-primary-100/90 hover:text-background-50 transition-colors"
                >
                  电影大全
                </Link>
              </li>
              <li>
                <Link
                  to="/category/tv"
                  className="text-primary-100/90 hover:text-background-50 transition-colors"
                >
                  电视剧列表
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-primary-100/90 hover:text-background-50 transition-colors">
                  影视资讯
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4 font-label tracking-wide">
              关于平台
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-primary-100/90 hover:text-background-50 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-primary-100/90 hover:text-background-50 transition-colors">
                  搜索影视
                </Link>
              </li>
              <li>
                <span className="text-primary-100/70">内容均为演示数据</span>
              </li>
              <li>
                <span className="text-primary-100/70">本站不提供在线播放与下载</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4 font-label tracking-wide">
              联系我们
            </h4>
            <ul className="space-y-3 text-sm text-primary-100/90">
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-base">
                  <i className="ri-mail-line"></i>
                </span>
                hello@peachcinema.demo
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-base">
                  <i className="ri-wechat-line"></i>
                </span>
                peach_cinema
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-base">
                  <i className="ri-time-line"></i>
                </span>
                每日 09:00 - 22:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-100/70">
          <p>© 2026 蜜桃成熟 Peach Cinema · 演示站点，内容仅供学习参考</p>
          <p>影视作品与演员信息均为虚构示例</p>
        </div>
      </div>
    </footer>
  );
}